export const NonExclusiveType = {
  DEFAULT_PRICE: "DEFAULT_PRICE",
  ROYALTIES: "ROYALTIES"
}